import {
  Card,
  CardContent,
  Stack,
  Box,
  Typography,
  useTheme,
} from "@mui/material";

const ClientItem = ({ clientData }) => {
  const {
    banner_pic,
    info,
    title,
    background_c = "#ffffff",
    info_c = "#666",
    title_c = "#111",
  } = clientData;

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 1000,
        mx: "auto",
        borderRadius: 2,
        bgcolor: background_c,
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        },
      }}
    >
      <CardContent sx={{ px: 3, py: 2 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          {/* Small Image */}
          <Box
            component="img"
            src={banner_pic}
            alt={title}
            sx={{
              width: 74,
              height: 74,
              objectFit: "contain",
              borderRadius: 1,
              backgroundColor: "#fafafa",
              p: 1,
              boxShadow: 1,
            }}
          />

          {/* Minimal Text */}
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={500}
              color={title_c}
              sx={{ fontSize: "1rem" }}
            >
              {title}
            </Typography>

            <Typography
              variant="body2"
              color={info_c}
              sx={{ fontSize: "0.875rem", mt: 0.5 }}
            >
              {info}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ClientItem;
